<template>
  <div>
    <!-- Dialog to Create & Edit a Notes -->
    <Dialog
      v-if="!customerFormDialog"
      :key="noteDialogKey"
      :visible.sync="noteDialog1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Note Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteHeader">Note Subject *</label>
          <InputText
            id="noteHeader"
            v-model.trim="note.noteHeader"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !note.noteHeader }"
            :disabled="disabledArray.includes('noteHeader')"
          />
          <small class="p-invalid" v-if="submitted && !note.noteHeader"
            >Note Subject is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="noteTags">Note Tags</label>
          <MultiSelect
            v-model="noteTags"
            :options="tags"
            dataKey="id"
            optionLabel="tag"
            placeholder="Select tag/s"
            display="chip"
            :disabled="disabledArray.includes('noteTags')"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="customer">Customer *</label>
          <div class="p-inputgroup">
            <div style="display: contents" @click="openCustomer">
              <InputText
                id="customer"
                class="clearer"
                placeholder="Click button to search for customer"
                :disabled="true"
                v-model="customerName"
                :class="{ 'p-invalid': submitted && !note.customer }"
              >
              </InputText>
            </div>
            <Button
              icon="pi pi-search"
              class="p-button-warning"
              @click="() => (custSearchDialog = true)"
              :disabled="disabledArray.includes('Customer')"
            />
          </div>
          <small class="p-invalid" v-if="submitted && !note.customer"
            >Customer is required.</small
          >
        </div>
      </div>
      <div
        class="p-formgrid p-grid"
        v-if="!(customer1 && customer1.customerId)"
      >
        <div class="p-field p-col">
          <label for="quote">Enquiry</label>
          <div class="p-inputgroup">
            <div style="display: contents" @click="openEnquiry">
              <InputText
                class="clearer"
                placeholder="Click button to search for enquiry"
                :disabled="true"
                v-model="selectedEnquiry.oppDescription"
              >
              </InputText>
            </div>
            <Button
              icon="pi pi-search"
              class="p-button-warning"
              @click="enquirySelectionDialog = true"
              :disabled="disabledArray.includes('enquiry')"
            />
          </div>
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="assignFor">User</label>
          <Dropdown
            v-model="assignFor"
            :showClear="true"
            :options="users"
            dataKey="id"
            optionLabel="fullName"
            placeholder="Select User"
            :filter="true"
            :disabled="disabledArray.includes('user')"
          />
        </div>
        <div class="p-field p-col">
          <label for="noteRead">Note Read</label>
          <br />

          <ToggleButton
            v-model="note.noteRead"
            onLabel="Yes"
            offLabel="No"
            onIcon="pi pi-check"
            offIcon="pi pi-times"
            style="width: 100%"
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Note Details</label>
          <Textarea
            placeholder=""
            :autoResize="true"
            rows="6"
            v-model="note.noteDetails"
            :disabled="disabledArray.includes('noteDetails')"
          />
        </div>
      </div>
      <template #footer v-if="!disabledArray.includes('buttons')">
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="$emit('close')"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="saveNote"
        />
      </template>
    </Dialog>

    <!-- Customer form -->
    <Dialog
      v-else-if="customerFormDialog"
      :visible.sync="customerFormDialog"
      :style="{ width: '700px', overflowY: 'auto' }"
      header="Customer Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="custName">Customer Name *</label>
          <InputText
            id="custName"
            v-model.trim="customer.custName"
            required="true"
            :class="{ 'p-invalid': customerSubmitted && !customer.custName }"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.custName"
            >Customer Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address1">House</label>
          <InputText
            id="address1"
            v-model.trim="customer.address1"
            :class="{ 'p-invalid': customerSubmitted && !customer.address1 }"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address1"
            >Address1 is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address2">Street</label>
          <InputText
            id="address2"
            v-model.trim="customer.address2"
            :class="{ 'p-invalid': customerSubmitted && !customer.address2 }"
            required="false"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address2"
            >Address2 is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address3">Sub Area</label>
          <InputText
            id="address3"
            v-model.trim="customer.address3"
            :class="{ 'p-invalid': customerSubmitted && !customer.address3 }"
            required="false"
            autofocus
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address3"
            >Address3 is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address4">City/Town</label>
          <CustomDropDown
            :allOptions="citiesTowns"
            :disabled="false"
            optionLabel="cityTownName"
            dataKey="id"
            :forceSelection="true"
            :showDropDownOnStart="true"
            :currentValue="cityTown1"
            placeholder="Select City/Town"
            style="width: 100%"
            @selected="setSelection"
            :inputClass="{
              'p-invalid': customerSubmitted && !customer.cityTown
            }"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.cityTown"
            >City/Town is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="postCode">Post Code</label>
          <InputText
            id="postCode"
            v-model.trim="postCode"
            required="false"
            :class="{ 'p-invalid': customerSubmitted && !customer.postCode }"
            autofocus
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.postCode"
            >Post Code is required.</small
          >
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col" v-if="duplicateChecking">
          <div class="errorMsg" style="background-color: dodgerblue;">
            <span class="errorSpan">
              Checking for duplicate customers...
            </span>
          </div>
        </div>
        <div
          class="p-field p-col"
          v-if="!duplicateChecking && duplicates.length"
        >
          <div class="errorMsg">
            <span class="errorSpan pr-5">
              Possible duplicate customers: {{ duplicates.length }}
            </span>
            <span
              class="errorSpan errorPointer pr-3"
              @click="displayDuplicateMessage = true"
            >
              View duplicates
            </span>
            <span
              class="errorSpan errorPointer"
              @click="checkForDuplicate()"
              v-if="
                lastEnteredName !== customer.custName ||
                  lastEnteredAddress1 !== customer.address1 ||
                  lastEnteredAddress2 !== customer.address2 ||
                  lastEnteredAddress3 !== customer.address3 ||
                  lastEnteredCityTown !==
                    (customer.cityTown && customer.cityTown.id) ||
                  lastEnteredPostCode !== customer.postCode
              "
            >
              Check again
            </span>
          </div>
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="region">Region</label>
          <InputText
            v-if="customer.region"
            id="region"
            v-model.trim="customer.region.regionName"
            :disabled="true"
            required="false"
          />
          <InputText v-else id="region" :disabled="true" required="false" />
        </div>
        <div class="p-field p-col">
          <label for="salesExec">Branch</label>
          <InputText
            id="branch"
            v-model.trim="branch.branchName"
            :disabled="true"
            required="false"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="salesExec">Sales Exec</label>
          <InputText
            id="salesExec"
            v-model.trim="salesExec.salesExecName"
            :disabled="true"
            required="false"
            autofocus
          />
        </div>
        <div class="p-field p-col">
          <label for="customerType">Customer Type</label>
          <Dropdown
            id="customerType"
            v-model="customerType"
            :options="customertypes"
            optionLabel="typeName"
            placeholder="Select Customer Type"
            :class="{
              'p-invalid': customerSubmitted && !customer.customerType
            }"
            :showClear="true"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.customerType"
            >Customer Type is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="phoneNo">Phone No</label>
          <InputText
            id="phoneNo"
            v-model.trim="customer.phoneNo"
            :class="{ 'p-invalid': customerSubmitted && !customer.phoneNo }"
            required="false"
          />
          <small class="p-invalid" v-if="customerSubmitted && !customer.phoneNo"
            >Phone number is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="mobile">Email</label>
          <InputText
            id="mobile"
            v-model.trim="customer.email"
            required="false"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="mainNotes">Notes</label>
          <InputText
            id="mainNotes"
            v-model.trim="customer.mainNotes"
            required="false"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="hideAndOpenCustomer"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="saveCustomer"
        />
      </template>
    </Dialog>

    <!-- Customer duplicate message -->
    <Dialog header="Header" :visible.sync="customerDuplicateMessage">
      <template #header>
        <h3>Duplicate error</h3>
      </template>

      The following Customer seems to be a duplicate of some customers. Please
      confirm if you wish to still save this customer?

      <template #footer>
        <Button
          @click="customerDuplicateMessage = false"
          label="No"
          icon="pi pi-times"
          class="p-button-text"
        />
        <Button
          @click="sendDuplicateCustomer()"
          label="Yes"
          icon="pi pi-check"
          autofocus
        />
      </template>
    </Dialog>

    <CustomerSearchDialog
      :key="loadCustomersAgain"
      :custSearchDialog="custSearchDialog"
      :preSelectedCustomer="preSelectedCustomer"
      :disabledStep="2"
      @close="custSearchDialog = false"
      @select="updateCustomer"
      @selectCustomer="selectCustomerForm"
    />

    <EnquirySelectionDialog
      :key="enquirySelectionKey"
      :enquirySelectionDialog="enquirySelectionDialog"
      :enquiries="enquiries"
      :requestingEnquiries="requestingEnquiries"
      @close="enquirySelectionDialog = false"
      @selected="updateEnquiry"
    />

    <duplicateTable
      v-if="displayDuplicateMessage"
      :duplicateDialog="displayDuplicateMessage"
      :dataId="'customerId'"
      :name="'Customer'"
      :namePlural="'Customers'"
      :list="duplicates"
      :disabledArr="['buttons']"
      @close="displayDuplicateMessage = false"
      @selected-customer="setCustomerSelection"
    />
  </div>
</template>

<script>
import TagsService from "@/service/TagsService";
import CustomerService from "@/service/CustomerService";
import UserService from "@/service/UserService";
import QuotationService from "@/service/QuotationService";

import CustomerSearchDialog from "../customer/CustomerSearchDialog";
import EnquirySelectionDialog from "../opportunity/EnquirySelectionDialog";
import duplicateTable from "../customer/duplicateDialog";

import {
  noteRequest,
  customerLessDataRequest,
  customerConf
} from "@/mbp/universalComponents/sendRequest";

export default {
  components: {
    CustomerSearchDialog,
    EnquirySelectionDialog,
    duplicateTable
  },
  props: {
    reload: {
      type: Number,
      required: true
    },
    noteDialog: {
      type: Boolean,
      required: true
    },
    customer1: {
      type: Object,
      required: false
    },
    enquiry1: {
      type: Object,
      required: false
    },
    noteToEdit: {
      type: Object,
      required: false
    },
    disabledArray: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: () => ({
    tagsService: new TagsService(),
    customerService: new CustomerService(),
    userService: new UserService(),
    quotationService: new QuotationService(),
    noteDialogKey1: 0,
    note: {},
    submitted: false,
    tags: [],
    noteTags: [],
    customerName: "",
    customer: {},
    postCode: "",
    branch: {},
    salesExec: {},
    customerType: {},
    customerSubmitted: false,
    custSearchDialog: false,
    customerFormDialog: false,
    loadCustomersAgain1: 0,
    customerDuplicateMessage: false,
    // jobTitles: [],
    jobFunctions: [],
    citiesTowns: [],
    disabledArr: [],
    duplicateCustCode: null,
    customertypes: [],
    contactSubmitted: false,
    selectedCustomer: {},
    users: [],
    assignFor: {},
    enquirySelectionKey1: 0,
    sendingRequest: false,
    cityTown1: {},
    enquirySelectionDialog: false,
    enquiries: [],
    requestingEnquiries: false,
    selectedEnquiry: {},
    preSelectedCustomer: {},

    duplicates: [],
    duplicateChecking: false,
    lastEnteredName: "",
    lastEnteredPostCode: "",
    lastEnteredAddress1: "",
    lastEnteredAddress2: "",
    lastEnteredAddress3: "",
    lastEnteredCityTown: "",
    displayDuplicateMessage: false
  }),
  computed: {
    enquirySelectionKey: {
      set() {
        this.enquirySelectionKey1++;
      },
      get() {
        return "enquirySelectionKey-" + this.enquirySelectionKey1.toString();
      }
    },
    loadCustomersAgain: {
      set() {
        this.loadCustomersAgain1++;
      },
      get() {
        return "loadCustomersAgain-" + this.loadCustomersAgain1.toString();
      }
    },
    noteDialogKey: {
      set() {
        this.noteDialogKey1++;
      },
      get() {
        return "noteDialogKey-" + this.noteDialogKey1.toString();
      }
    },
    noteDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.noteDialog;
      }
    }
  },
  created() {
    this.setupComponent();

    this.userService
      .getAllActiveUsers()
      .then(data => {
        this.users = data;
      })
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting users",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeUsers"'
        });
      });

    if (this.customer1 && this.customer1.customerId) {
      this.selectedCustomer = this.customer1;
    }
  },
  watch: {
    customer1(val) {
      this.selectedCustomer = this.customer1;
    },
    selectedEnquiry(val) {
      if (val && val.sQuoteNo) {
        this.note.opportunity = val.oppId;
      }
    },
    assignFor(val) {
      this.note.assignFor = val;
    },
    selectedCustomer(val) {
      if (val && val.customerId) {
        this.note.customer = val;
        this.customerName = this.selectedCustomer.custName;
      }
    },
    cityTown1(val) {
      val && val.id
        ? (this.customer.cityTown = val)
        : (this.customer.cityTown = null);
    },
    customerType(val) {
      val && val.id
        ? (this.customer.customerType = val)
        : (this.customer.customerType = null);
    },
    postCode(val) {
      this.customer.postCode = val;

      this.customerService
        .getCustomerRegion(val)
        .then(res => {
          if (res[0] && res[0].id) {
            this.customer.region = {
              id: parseInt(res[0].regionCode),
              regionName: res[0].regionName
            };
            if (res[0].salesExec) {
              this.customer.salesExec = res[0].salesExec;
              this.salesExec = res[0].salesExec;
            }
            if (res[0].mbpBranch) {
              this.customer.mbpBranch = res[0].mbpBranch;
              this.branch = res[0].mbpBranch;
            }
          } else {
            throw new Error("Nothing found");
          }
        })
        .catch(err => {
          this.customer.region = {};
          this.branch = {};
          this.customer.mbpBranch = {};
          this.salesExec = {};
          this.customer.salesExec = {};
        });
    },
    noteTags(val) {
      this.note.noteTags = val;
    },
    reload(val) {
      this.setupComponent();
      this.noteDialogKey++;
    }
  },
  methods: {
    openCustomer() {
      if (this.note && this.note.customer && this.note.customer.customerId) {
        this.$emit("close");
        this.$router.push({
          path: "/customers/" + this.note.customer.customerId + "/detail",
          params: { custid: this.note.customer.customerId }
        });
      }
    },
    openEnquiry() {
      if (this.note && this.note.opportunity && this.note.opportunity.oppId) {
        this.$emit("close");
        this.$router.push({
          path: "/enquiries/" + this.note.opportunity.oppId + "/detail",
          params: { oppId: this.note.opportunity.oppId }
        });
      }
    },
    setCustomerSelection(customer) {
      this.displayDuplicateMessage = false;

      this.contactFormDialog = false;
      this.customerFormDialog = false;
      this.custSearchDialog = true;
      this.loadCustomersAgain++;
      this.preSelectedCustomer = customer;
      this.customer = {};
    },
    checkForDuplicate() {
      if (
        this.customer &&
        this.customer.custName &&
          this.customer.address1 &&
          this.customer.address2 &&
          this.customer.address3 &&
          this.customer.cityTown &&
          this.customer.cityTown.id &&
          this.customer.postCode &&
        (this.lastEnteredName !== this.customer.custName ||
          this.lastEnteredAddress1 !== this.customer.address1 ||
          this.lastEnteredAddress2 !== this.customer.address2 ||
          this.lastEnteredAddress3 !== this.customer.address3 ||
          this.lastEnteredCityTown !== this.customer.cityTown.id ||
          this.lastEnteredPostCode !== this.customer.postCode)
      ) {
        //

        this.lastEnteredName = this.customer.custName;
        this.lastEnteredAddress1 = this.customer.address1;
        this.lastEnteredAddress2 = this.customer.address2;
        this.lastEnteredAddress3 = this.customer.address3;
        this.lastEnteredCityTown = this.customer.cityTown.id;
        this.lastEnteredPostCode = this.customer.postCode;

        this.duplicateChecking = true;
        this.customerService
          .getDupCustomers({
            custName: this.customer.custName,
            address1: this.customer.address1,
            address2: this.customer.address2,
            address3: this.customer.address3,
            cityTown: this.customer.cityTown.id,
            postCode: this.customer.postCode,
            address4: ""
          })
          .then(data => {
            this.duplicateChecking = false;
            //
          })
          .catch(error => {
            //
            this.duplicateChecking = false;
            this.duplicates = [];

            if (error && error.response && error.response.status === 409) {
              this.duplicates = error.response.data;
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while checking for duplicate enquiries.",
                life: 5000
              });
            }
          });
      }
    },
    updateEnquiry(enquiry) {
      this.selectedEnquiry = enquiry;
      this.enquirySelectionDialog = false;
      this.selectedCustomer = {
        custName: enquiry.customerName,
        customerId: enquiry.customerId
      };
    },
    setupTags() {
      if (this.noteToEdit && this.noteToEdit.noteTags) {
        let a = this.noteToEdit.noteTags.split(",");
        if (!a[a.length - 1]) {
          a.pop();
        }
        if (this.tags) {
          this.noteTags = a.map(tag => this.tags.find(t => t.tag === tag));
        } else {
          this.noteTags = a;
        }
      }
    },
    setupComponent() {
      this.noteTags = [];
      this.note = {};
      this.submitted = false;
      this.selectedCustomer = {};
      this.selectedEnquiry = {};
      this.assignFor = {};

      this.custSearchDialog = false;

      this.getTagsOfType();
      //

      if (this.noteToEdit) {
        Object.keys(this.noteToEdit).forEach(key => {
          //

          if (key === "noteTags" && typeof this.noteToEdit[key] === "string") {
            this.setupTags();
          } else if (key === "customer") {
            this.selectedCustomer = this.noteToEdit[key];
            this.customerName = this.noteToEdit[key].custName;
          } else if (key === "enquiry") {
            this.selectedEnquiry = this.noteToEdit[key];
          } else if (key === "assignFor") {
            this.assignFor = this.noteToEdit[key];
          } else {
            this.note[key] = this.noteToEdit[key];
          }
        });
      }

      if (this.customer1 && this.customer1.customerId) {
        this.selectedCustomer = this.customer1;
      }
      if (this.enquiry1 && this.enquiry1.oppId) {
        this.selectedEnquiry = this.enquiry1;
      }

      // C-S7b: note = {} above, and re-selecting the same enquiry / customer does not fire their
      // watchers again, so a second new note in the same visit lost its enquiry link. Set both here.
      if (this.selectedEnquiry && this.selectedEnquiry.oppId) {
        this.note.opportunity = this.selectedEnquiry.oppId;
      }
      if (this.selectedCustomer && this.selectedCustomer.customerId) {
        this.note.customer = this.selectedCustomer;
      }

      this.customerService
        .getAllJobFunctions()
        .then(data => (this.jobFunctions = data))
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting jobFunctions",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "jobFunctions"'
          });
        });
      this.customerService
        .getAllActiveCustomerTypes()
        .then(data => (this.customertypes = data))
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer types",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeCustomerTypes"'
          });
        });

      this.customerService
        .getAllActiveCitiesTowns()
        .then(data => (this.citiesTowns = data))
        .catch(error => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "citiesTowns"'
          });
        });
    },
    updateCustomer(e) {
      //
      if (e.customer) {
        if (
          this.selectedEnquiry &&
          e.customer.customerId !== this.selectedEnquiry.customerId
        ) {
          this.selectedEnquiry = {};
        }

        this.selectedCustomer = e.customer;

        this.customerService
          .getCustomerInfo(e.customer.customerId)
          .then(data => {
            this.selectedCustomer = data;
          })
          .catch(e => {
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer info",
            //   life: 5000,
            // })
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "customerInfo/{customerId}"'
            });
          });
      }
    },
    sendDuplicateCustomer() {
      customerConf(this, "NoteForm.vue");
    },
    saveCustomer() {
      this.customerSubmitted = true;

      if (!this.duplicateCustCode) {
        this.sendingRequest = true;
        customerLessDataRequest(this, "NoteForm.vue");
      }
    },
    hideAndOpenCustomer() {
      this.preSelectedCustomer = {};
      this.customerFormDialog = false;
      this.custSearchDialog = true;
    },
    selectCustomerForm() {
      this.customer = {};
      this.postCode = "";
      this.branch = {};
      this.salesExec = {};
      this.customerType = {};
      this.cityTown1 = {};
      this.customerSubmitted = false;
      this.custSearchDialog = false;
      this.customerFormDialog = true;

      setTimeout(() => {
        let a = document.getElementById("custName");
        if (a) a.focus();
      }, 100);
    },
    saveNote() {
      this.submitted = true;
      this.sendingRequest = true;

      if (!this.note.customer && this.customer1) {
        this.note.customer = this.customer1.customerId;
      }

      noteRequest(this, "NoteForm.vue");
    },
    getTagsOfType() {
      this.tagsService
        .getTagsOfType("NOTES")
        .then(data => {
          this.tags = data;
          this.setupTags();
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting tags for NOTES",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "tags/type"'
          });
        });
    },
    setSelection({ value, index }) {
      //
      this.cityTown1 = value;
      this.checkForDuplicate();
    }
  }
};
</script>

<style></style>
